export const ROWS_PER_PAGE = 25;

export const QUERY_DEBOUNCE_MS = 400;

export const MAX_FILTERED_ADS = 250;

export const FATIGUE_ROWS_PER_PAGE = 20;

export const DRILL_ROWS_PER_PAGE = 10;

export const GROUP_ADS_PER_PAGE = 24;

// Relative date ranges resolve on the server in the zone each query names.
export const TIMEZONE = Intl.DateTimeFormat().resolvedOptions().timeZone;
